module.exports = __webpack_public_path__ + "img/mentor-badge.cfbb6933.svg";